import type { IntakeI18nLabel } from '@ops-matrix/shared-types';

/** Extract a plain string from an i18n label (string | { default, en?, es? } | undefined). */
export const getI18nString = (value: string | IntakeI18nLabel | undefined): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.default || '';
};
